/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Service endpoint type */
export enum ServiceEndpointType {
  AIAgentService,
  DIDCommMessaging,
  CredentialRepository,
  LinkedDomains,
  Custom,
}

export type ServiceEndpointTypeArgs = ServiceEndpointType;

export function getServiceEndpointTypeEncoder(): FixedSizeEncoder<ServiceEndpointTypeArgs> {
  return getEnumEncoder(ServiceEndpointType);
}

export function getServiceEndpointTypeDecoder(): FixedSizeDecoder<ServiceEndpointType> {
  return getEnumDecoder(ServiceEndpointType);
}

export function getServiceEndpointTypeCodec(): FixedSizeCodec<
  ServiceEndpointTypeArgs,
  ServiceEndpointType
> {
  return combineCodec(
    getServiceEndpointTypeEncoder(),
    getServiceEndpointTypeDecoder(),
  );
}
